exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".centerdiv[data-v-17fbb784]{height:auto;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/welcome.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,iBAAmB,CACpB","file":"welcome.vue","sourcesContent":["\n.centerdiv[data-v-17fbb784]{\n  height: auto;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17fbb784","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/welcome.vue
// module id = 566
// module chunks = 8